import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  RESET_USER_DETAILS,
  EMAIL_VALIDATION_REQUEST,
  EMAIL_VALIDATION_SUCCESS,
  EMAIL_VALIDATION_FAILURE
} from '../constants';

const initialLoginState = {
  user: {},
  userError: {},
  userSuccess: true,
  emailValidation: {},
  loader: false
};


export default (state = initialLoginState, action = {}) => {
  //This is to ensure immutability of state
  let newState = { ...state };

  switch (action.type) {
    case REGISTER_REQUEST:
      newState.user = {};
      newState.userError = {};
      newState.userSuccess = false;
      newState.loader = true;
      return newState;
    case REGISTER_SUCCESS:
      newState.user = action.body;
      newState.userSuccess = true;
      newState.userError = {};
      newState.loader = false;
      return newState;
    case REGISTER_FAILURE:
      JSON.parse(action.exception).errors.forEach((error) => {
        if(error?.msg?.includes("username"))
          newState.userError.username = true
        if(error?.msg?.includes("email"))
          newState.userError.duplicateEmail = true
      });
      newState.userSuccess = false;
      newState.loader = false;
      return newState;
    case RESET_USER_DETAILS:
      newState.user = {};
      newState.userError = {};
      newState.userSuccess = false;
      return newState;
    case EMAIL_VALIDATION_REQUEST:
      newState.emailValidationLoader = true;
      return newState;
    case EMAIL_VALIDATION_SUCCESS:
      newState.emailValidationLoader = false;
      newState.emailValidation = action.data;
      return newState;
    case EMAIL_VALIDATION_FAILURE:
      const emailValidation = { isEmailValidated: false, }
      newState.emailValidation = emailValidation;
      newState.emailValidationLoader = false;
      return newState;
    default:
      return state;
  }
};
